// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../utils/colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%271.8%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolygon points=%2712 2 2 7 12 12 22 7 12 2%27/%3E%3Cpolyline points=%272 12 12 17 22 12%27/%3E%3Cpolyline points=%272 17 12 22 22 17%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #root {
  height: 100%;
  width: 100%;
}

.map-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

/* ---- Top bar ---- */
.map-top-bar {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 11;
  display: flex;
  align-items: center;
  gap: 12px;
}

.map-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(23, 38, 49, 0.5);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 24px;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  transition: background 0.2s, border-color 0.2s;
  flex-shrink: 0;
}

.map-back-btn:hover {
  background: rgba(238, 91, 67, 0.75);
  border-color: rgba(238, 91, 67, 0.85);
}

.map-back-icon {
  font-size: 15px;
  line-height: 1;
}

.map-back-label {
  white-space: nowrap;
}

/* ---- LOGOS ---- */
.map-logo-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(23, 38, 49, 0.5);
  backdrop-filter: blur(8px);
  padding: 8px 14px;
  border-radius: 20px;
}

.map-logo {
  height: 32px;
}

/* ================= MOBILE FIX ================= */
@media (max-width: 480px) {

  .map-top-bar {
    top: 10px;
    left: 10px;
    gap: 6px;
  }

  /* 🔥 BACK BUTTON = ICON ONLY */
  @media (max-width: 480px) {
  .map-back-btn {
    padding: 0;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0;
    position: relative;
  }

  .map-back-btn::before {
    content: "←";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    line-height: 1;
  }
}

  .map-back-label {
    display: none;
  }

  .map-logo-container {
    padding: 6px 8px;
    gap: 5px;
    flex-direction: column;
    align-items: center;
  }

  .map-logo {
    height: 20px;
  }
}

/* ---- Mapbox overrides ---- */
.mapboxgl-ctrl-logo,
.mapboxgl-ctrl-attrib {
  display: none !important;
}


.alert-cta-desktop {
  display: block;
}

.alert-cta-card {
  position: absolute;
  bottom: 24px;
  left: 24px;
  z-index: 10;
  background: var(--map-surface);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid var(--map-border);
  border-radius: 16px;
  box-shadow:
    0 0 24px rgba(225, 6, 19, 0.15),
    0 8px 32px rgba(0, 0, 0, 0.45);
  padding: 16px 18px;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.alert-cta-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.alert-cta-icon {
  font-size: 20px;
}

.alert-cta-title {
  color: var(--map-danger);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
}

.alert-cta-message {
  margin: 0;
  font-size: 13px;
  color: var(--map-text-muted);
  line-height: 1.55;
}

.alert-cta-message strong {
  color: var(--map-text-primary);
}

.alert-cta-divider {
  height: 1px;
  background: var(--map-border);
}

.alert-fab {
  display: none;
  position: absolute;
  bottom: 24px;
  left: 24px;
  z-index: 10;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: var(--map-danger-gradient);
  color: white;
  font-size: 22px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(225, 6, 19, 0.4);
  transition: transform 0.2s, box-shadow 0.2s;
}

.alert-fab:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 24px rgba(225, 6, 19, 0.55);
}

.alert-fab:active {
  transform: scale(0.95);
}

.alert-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 20;
}

.alert-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 21;
  background: var(--map-surface);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid var(--map-border);
  border-radius: 20px 20px 0 0;
  padding: 24px 20px 32px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  animation: slideUp 0.3s ease;
}
.alert-cta-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.alert-cta-close {
  background: transparent;
  border: 1px solid var(--map-border);
  border-radius: 50%;
  color: var(--map-text-muted);
  width: 22px;
  height: 22px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  margin-left: auto;       /* pushes it to the right */
  line-height: 1;
  transition: border-color 0.2s, color 0.2s;
}
.alert-cta-close:hover {
  border-color: var(--map-danger);
  color: var(--map-text-primary);
}

.alert-fab-desktop {
  display: none;           
}

@media (min-width: 768px) {
  .alert-fab-desktop {
    display: flex;
    position: absolute;
    bottom: 1rem;            
    left: 1rem;
  }

}

@keyframes slideUp {
  from { transform: translateY(100%); }
  to   { transform: translateY(0); }
}

.alert-modal-close {
  position: absolute;
  top: 14px;
  right: 18px;
  background: transparent;
  border: none;
  color: var(--map-text-muted);
  font-size: 18px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s, color 0.2s;
}

.alert-modal-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--map-text-primary);
}

.signup-submit-btn {
  margin-top: 0;
  border-radius: 24px;
  border: none;
  background: var(--map-danger-gradient);
  color: var(--map-text-primary);
  font-size: 13px;
  font-weight: 700;
  width: 96%;
  letter-spacing: 1.5px;
  padding: 13px 48px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
}

.signup-submit-btn:hover {
  opacity: 0.9;
}

.signup-submit-btn:active {
  transform: scale(0.97);
}

.mapboxgl-ctrl-top-right {
  top: 14px;
  right: 16px;
  left: auto;
}

.mapboxgl-ctrl-geocoder {
  background: var(--map-ctrl-bg) !important;
  backdrop-filter: blur(14px) !important;
  -webkit-backdrop-filter: blur(14px) !important;
  border: 1px solid var(--map-ctrl-border) !important;
  border-radius: 40px !important;
  box-shadow:
    0 0 18px rgba(225, 6, 19, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.04) !important;
  min-width: 320px !important;
  width: 360px !important;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.mapboxgl-ctrl-geocoder:focus-within {
  border-color: var(--map-border-focus) !important;
  box-shadow:
    0 0 28px rgba(225, 6, 19, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.07) !important;
}

.mapboxgl-ctrl-geocoder--icon-search {
  fill: var(--map-danger) !important;
  top: 10px !important;
  left: 14px !important;
  width: 20px !important;
  height: 20px !important;
}

.mapboxgl-ctrl-geocoder--input {
  background: transparent !important;
  color: var(--map-text-primary) !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  height: 42px !important;
  padding: 0 40px 0 42px !important;
}

.mapboxgl-ctrl-geocoder--input::placeholder {
  color: var(--map-text-muted) !important;
}

.mapboxgl-ctrl-geocoder--input:focus {
  outline: none !important;
}

.mapboxgl-ctrl-geocoder--button {
  background: transparent !important;
}

.mapboxgl-ctrl-geocoder--icon-close {
  fill: var(--map-text-muted) !important;
  margin-top: 10px !important;
}

.mapboxgl-ctrl-geocoder .suggestions {
  background: var(--map-bg) !important;
  backdrop-filter: blur(16px) !important;
  border: 1px solid var(--map-border) !important;
  border-top: none !important;
  border-radius: 0 0 18px 18px !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5) !important;
  margin-top: 2px !important;
  overflow: hidden;
}

.mapboxgl-ctrl-geocoder .suggestions > li > a {
  color: var(--map-text-muted) !important;
  font-size: 13px !important;
  padding: 10px 16px !important;
  border-bottom: 1px solid var(--map-border) !important;
  transition: background 0.15s;
}

.mapboxgl-ctrl-geocoder .suggestions > .active > a,
.mapboxgl-ctrl-geocoder .suggestions > li > a:hover {
  background: var(--map-ctrl-hover) !important;
  color: var(--map-text-primary) !important;
}

.mapboxgl-ctrl-geocoder .suggestions > li:last-child > a {
  border-bottom: none !important;
}

.mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--suggestion-title {
  color: var(--map-text-primary) !important;
  font-weight: 500 !important;
}

.mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--suggestion-address {
  color: var(--map-text-muted) !important;
  font-size: 11.5px !important;
}

.legend-wrapper {
  position: absolute;
  bottom: 250px;
  left: 24px;
  z-index: 10;
}

.mapboxgl-ctrl-bottom-right {
  bottom: 20px !important;
  right: 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-end;
}

.mapboxgl-ctrl-group button .mapboxgl-ctrl-icon {
  background-size: 26px 26px !important;
}

.mapboxgl-ctrl-group {
  background: var(--map-ctrl-bg) !important;
  backdrop-filter: blur(14px) !important;
  -webkit-backdrop-filter: blur(14px) !important;
  border: 1px solid var(--map-ctrl-border) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
  overflow: hidden;
}

.mapboxgl-ctrl-group:not(:last-child) {
  margin-bottom: 0 !important;
}

.mapboxgl-ctrl-group button {
  background: transparent !important;
  border: none !important;
  border-bottom: 1px solid var(--map-border) !important;
  width: 36px !important;
  height: 36px !important;
  cursor: pointer !important;
  transition: background 0.18s !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.mapboxgl-ctrl-group button:last-child {
  border-bottom: none !important;
}

.mapboxgl-ctrl-group button:hover {
  background: var(--map-ctrl-hover) !important;
}

.mapboxgl-ctrl-group button:active {
  background: var(--map-ctrl-active) !important;
}

.mapboxgl-ctrl-zoom-in .mapboxgl-ctrl-icon,
.mapboxgl-ctrl-zoom-out .mapboxgl-ctrl-icon,
.mapboxgl-ctrl-compass .mapboxgl-ctrl-icon,
.mapboxgl-ctrl-fullscreen .mapboxgl-ctrl-icon,
.mapboxgl-ctrl-shrink .mapboxgl-ctrl-icon,
.mapboxgl-ctrl-geolocate .mapboxgl-ctrl-icon {
  filter: var(--map-icon-filter) !important;
  transition: filter 0.2s ease !important;
}

.mapboxgl-ctrl-group button:hover .mapboxgl-ctrl-icon {
  filter: var(--map-icon-filter-hover) !important;
}

.mapboxgl-ctrl-geolocate-active .mapboxgl-ctrl-icon {
  filter: var(--map-icon-filter-hover) !important;
}

.mapboxgl-user-location-dot {
  background-color: var(--map-danger) !important;
  box-shadow: 0 0 0 4px rgba(225, 6, 19, 0.3) !important;
}

.mapboxgl-user-location-dot::before {
  background-color: rgba(225, 6, 19, 0.45) !important;
}

.legend-toggle-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px 20px;
  width: 100%;
  height: 100%;
  display: block;
  transition: opacity 0.2s ease;
}
/* ── Département popup ── */
.dept-popup .mapboxgl-popup-content {
  background: rgba(23, 38, 49, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 14px 18px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  color: #fff;
  min-width: 140px;
}

.dept-popup .mapboxgl-popup-tip {
  border-top-color: rgba(23, 38, 49, 0.95);
}

.dept-popup .mapboxgl-popup-close-button {
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
  padding: 6px 8px;
  right: 4px;
  top: 4px;
  border-radius: 6px;
  transition: color 0.2s, background 0.2s;
  line-height: 1;
}

.dept-popup .mapboxgl-popup-close-button:hover {
  color: #fff;
  background: rgba(225, 6, 19, 0.25);
}

.dept-popup-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 12px; 
}

.dept-popup-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--map-text-muted, #8a9ba8);
}

.dept-popup-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--map-text-primary, #fff);
}

.dept-popup-id {
  font-size: 11px;
  color: var(--map-text-muted, #8a9ba8);
  margin-top: 2px;
}
.legend-toggle-icon.legend-hidden {
  opacity: 0.4;
}

.legend-toggle-icon.legend-hidden::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 2px;
  background: var(--map-danger);
  transform: translate(-50%, -50%) rotate(-45deg);
  border-radius: 1px;
}

.mapboxgl-ctrl-group button .legend-toggle-icon {
  filter: var(--map-icon-filter) !important;
  transition: filter 0.2s ease !important;
}

.mapboxgl-ctrl-group button:hover .legend-toggle-icon {
  filter: var(--map-icon-filter-hover) !important;
}
.alert-fab {
  z-index: 100;           /* higher than mapbox controls */
  pointer-events: auto;
}

.alert-fab-desktop {
  z-index: 100;          
}

.mapboxgl-ctrl-group {
  pointer-events: auto;   
}
@media (max-width: 480px) {
  .map-container {
    height: 115dvh; 
  }
}
@media (max-width: 1000px) {
  
 .mapboxgl-ctrl-top-right {
top: 14px;
right: 14px;
left: auto; 
}
.mapboxgl-ctrl-geocoder {
min-width: 0 !important;
width: 200px !important; 
}

  .mapboxgl-ctrl-geocoder--input {
    font-size: 14px !important;
    height: 40px !important;
  }

  .legend-wrapper {
    bottom: 120px;
    left: 12px;
  }

  .alert-cta-desktop {
    display: none !important;
  }

  .alert-fab {
    display: flex;
  }

  .mapboxgl-ctrl-bottom-right {
    bottom: 16px !important;
    right: 10px;
  }

  .mapboxgl-ctrl-group button {
    width: 34px !important;
    height: 34px !important;
  }

  .mapboxgl-ctrl-group button .mapboxgl-ctrl-icon {
    background-size: 22px 22px !important;
  }
}

@media (max-width: 480px) {
  .mapboxgl-ctrl-top-right {
top: 10px;
right: 10px;
left: 90px; 
}
.mapboxgl-ctrl-geocoder {
min-width: 0 !important;
width: 40% !important; 
border-radius: 32px !important;
}
  .mapboxgl-ctrl-geocoder--input {
    font-size: 15px !important;
    height: 44px !important;
  }

  .legend-wrapper {
    top: 100px;
    left: 10px;
  }

  .alert-fab {
    bottom: 120px;
    left: 16px;
    width: 52px;
    height: 52px;
    font-size: 24px;
  }

  .alert-modal {
    padding: 28px 18px 40px;
  }

  .forecast-timeline-container {
    bottom: 120px !important;
  }

  .forecast-timeline-pill {
    min-width: 240px;
    padding: 6px 12px;
  }

  .timeline-value {
    font-size: 15px;
  }

  .timeline-value.hour {
    font-size: 15px;
  }

  .timeline-timezone {
    font-size: 8px;
  }

  .timeline-play-btn {
    width: 32px;
    height: 32px;
  }

  .timeline-play-btn svg {
    width: 16px;
    height: 16px;
  }

 .map-container .mapboxgl-ctrl-bottom-right {
    bottom: 120px !important;
    right: 8px;
     z-index: 10;  
  }

  .map-container .mapboxgl-ctrl-group button {
    width: 32px !important;
    height: 32px !important;
  }

  .map-container .mapboxgl-ctrl-group button .mapboxgl-ctrl-icon {
    background-size: 20px 20px !important;
  }
}

@media (max-width: 360px) {
 .mapboxgl-ctrl-geocoder {
min-width: 0 !important;
width: 40% !important; 
border-radius: 32px !important;
}
  .mapboxgl-ctrl-geocoder--input {
    font-size: 15px !important;
    height: 44px !important;
  }

  .forecast-timeline-pill {
    min-width: 210px;
    padding: 5px 10px;
  }

  .timeline-value.date {
    font-size: 13px;
  }

  .timeline-value.hour {
    font-size: 14px;
  }

  .timeline-section.hour-section {
    min-width: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/templates/mapTemplate/MapTemplate.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,yCAAyC;EACzC,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,mDAAmD;AACnD;;EAEE;IACE,SAAS;IACT,UAAU;IACV,QAAQ;EACV;;EAEA,+BAA+B;EAC/B;EACA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,cAAc;EAChB;AACF;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,+BAA+B;AAC/B;;EAEE,wBAAwB;AAC1B;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;EACnB;;kCAEgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,uCAAuC;EACvC,4BAA4B;EAC5B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,iBAAiB,QAAQ,2BAA2B;EACpD,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;;AAEF;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,8CAA8C;EAC9C,mDAAmD;EACnD,8BAA8B;EAC9B;;sDAEoD;EACpD,2BAA2B;EAC3B,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;EAChD;;sDAEoD;AACtD;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,gCAAgC;EAChC,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,8CAA8C;EAC9C,2BAA2B;EAC3B,uCAAuC;EACvC,qDAAqD;EACrD,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,6BAA6B;EAC7B,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;;EAEE,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,8CAA8C;EAC9C,mDAAmD;EACnD,8BAA8B;EAC9B,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,qDAAqD;EACrD,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,uCAAuC;EACvC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;;;;;EAME,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;EAC9C,sDAAsD;AACxD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yDAAqV;EACrV,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;AACA,4BAA4B;AAC5B;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;AACjD;AACA;EACE,YAAY,YAAY,gCAAgC;EACxD,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;;CAEC;AACD,SAAS;AACT,WAAW;AACX,UAAU;AACV;AACA;AACA,uBAAuB;AACvB,uBAAuB;AACvB;;EAEE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;AACF,SAAS;AACT,WAAW;AACX,UAAU;AACV;AACA;AACA,uBAAuB;AACvB,qBAAqB;AACrB,8BAA8B;AAC9B;EACE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;CAED;IACG,wBAAwB;IACxB,UAAU;KACT,WAAW;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;CACC;AACD,uBAAuB;AACvB,qBAAqB;AACrB,8BAA8B;AAC9B;EACE;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import '../../utils/colors.css';\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body, #root {\n  height: 100%;\n  width: 100%;\n}\n\n.map-container {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n\n/* ---- Top bar ---- */\n.map-top-bar {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  z-index: 11;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.map-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(23, 38, 49, 0.5);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 24px;\n  padding: 10px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  transition: background 0.2s, border-color 0.2s;\n  flex-shrink: 0;\n}\n\n.map-back-btn:hover {\n  background: rgba(238, 91, 67, 0.75);\n  border-color: rgba(238, 91, 67, 0.85);\n}\n\n.map-back-icon {\n  font-size: 15px;\n  line-height: 1;\n}\n\n.map-back-label {\n  white-space: nowrap;\n}\n\n/* ---- LOGOS ---- */\n.map-logo-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: rgba(23, 38, 49, 0.5);\n  backdrop-filter: blur(8px);\n  padding: 8px 14px;\n  border-radius: 20px;\n}\n\n.map-logo {\n  height: 32px;\n}\n\n/* ================= MOBILE FIX ================= */\n@media (max-width: 480px) {\n\n  .map-top-bar {\n    top: 10px;\n    left: 10px;\n    gap: 6px;\n  }\n\n  /* 🔥 BACK BUTTON = ICON ONLY */\n  @media (max-width: 480px) {\n  .map-back-btn {\n    padding: 0;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0;\n    position: relative;\n  }\n\n  .map-back-btn::before {\n    content: \"←\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 16px;\n    line-height: 1;\n  }\n}\n\n  .map-back-label {\n    display: none;\n  }\n\n  .map-logo-container {\n    padding: 6px 8px;\n    gap: 5px;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .map-logo {\n    height: 20px;\n  }\n}\n\n/* ---- Mapbox overrides ---- */\n.mapboxgl-ctrl-logo,\n.mapboxgl-ctrl-attrib {\n  display: none !important;\n}\n\n\n.alert-cta-desktop {\n  display: block;\n}\n\n.alert-cta-card {\n  position: absolute;\n  bottom: 24px;\n  left: 24px;\n  z-index: 10;\n  background: var(--map-surface);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid var(--map-border);\n  border-radius: 16px;\n  box-shadow:\n    0 0 24px rgba(225, 6, 19, 0.15),\n    0 8px 32px rgba(0, 0, 0, 0.45);\n  padding: 16px 18px;\n  max-width: 350px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.alert-cta-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.alert-cta-icon {\n  font-size: 20px;\n}\n\n.alert-cta-title {\n  color: var(--map-danger);\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n}\n\n.alert-cta-message {\n  margin: 0;\n  font-size: 13px;\n  color: var(--map-text-muted);\n  line-height: 1.55;\n}\n\n.alert-cta-message strong {\n  color: var(--map-text-primary);\n}\n\n.alert-cta-divider {\n  height: 1px;\n  background: var(--map-border);\n}\n\n.alert-fab {\n  display: none;\n  position: absolute;\n  bottom: 24px;\n  left: 24px;\n  z-index: 10;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background: var(--map-danger-gradient);\n  color: white;\n  font-size: 22px;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(225, 6, 19, 0.4);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.alert-fab:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 24px rgba(225, 6, 19, 0.55);\n}\n\n.alert-fab:active {\n  transform: scale(0.95);\n}\n\n.alert-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  z-index: 20;\n}\n\n.alert-modal {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 21;\n  background: var(--map-surface);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-top: 1px solid var(--map-border);\n  border-radius: 20px 20px 0 0;\n  padding: 24px 20px 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  animation: slideUp 0.3s ease;\n}\n.alert-cta-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.alert-cta-close {\n  background: transparent;\n  border: 1px solid var(--map-border);\n  border-radius: 50%;\n  color: var(--map-text-muted);\n  width: 22px;\n  height: 22px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  margin-left: auto;       /* pushes it to the right */\n  line-height: 1;\n  transition: border-color 0.2s, color 0.2s;\n}\n.alert-cta-close:hover {\n  border-color: var(--map-danger);\n  color: var(--map-text-primary);\n}\n\n.alert-fab-desktop {\n  display: none;           \n}\n\n@media (min-width: 768px) {\n  .alert-fab-desktop {\n    display: flex;\n    position: absolute;\n    bottom: 1rem;            \n    left: 1rem;\n  }\n\n}\n\n@keyframes slideUp {\n  from { transform: translateY(100%); }\n  to   { transform: translateY(0); }\n}\n\n.alert-modal-close {\n  position: absolute;\n  top: 14px;\n  right: 18px;\n  background: transparent;\n  border: none;\n  color: var(--map-text-muted);\n  font-size: 18px;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.2s, color 0.2s;\n}\n\n.alert-modal-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--map-text-primary);\n}\n\n.signup-submit-btn {\n  margin-top: 0;\n  border-radius: 24px;\n  border: none;\n  background: var(--map-danger-gradient);\n  color: var(--map-text-primary);\n  font-size: 13px;\n  font-weight: 700;\n  width: 96%;\n  letter-spacing: 1.5px;\n  padding: 13px 48px;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s;\n}\n\n.signup-submit-btn:hover {\n  opacity: 0.9;\n}\n\n.signup-submit-btn:active {\n  transform: scale(0.97);\n}\n\n.mapboxgl-ctrl-top-right {\n  top: 14px;\n  right: 16px;\n  left: auto;\n}\n\n.mapboxgl-ctrl-geocoder {\n  background: var(--map-ctrl-bg) !important;\n  backdrop-filter: blur(14px) !important;\n  -webkit-backdrop-filter: blur(14px) !important;\n  border: 1px solid var(--map-ctrl-border) !important;\n  border-radius: 40px !important;\n  box-shadow:\n    0 0 18px rgba(225, 6, 19, 0.12),\n    inset 0 1px 0 rgba(255, 255, 255, 0.04) !important;\n  min-width: 320px !important;\n  width: 360px !important;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.mapboxgl-ctrl-geocoder:focus-within {\n  border-color: var(--map-border-focus) !important;\n  box-shadow:\n    0 0 28px rgba(225, 6, 19, 0.25),\n    inset 0 1px 0 rgba(255, 255, 255, 0.07) !important;\n}\n\n.mapboxgl-ctrl-geocoder--icon-search {\n  fill: var(--map-danger) !important;\n  top: 10px !important;\n  left: 14px !important;\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.mapboxgl-ctrl-geocoder--input {\n  background: transparent !important;\n  color: var(--map-text-primary) !important;\n  font-size: 13px !important;\n  letter-spacing: 0.3px !important;\n  height: 42px !important;\n  padding: 0 40px 0 42px !important;\n}\n\n.mapboxgl-ctrl-geocoder--input::placeholder {\n  color: var(--map-text-muted) !important;\n}\n\n.mapboxgl-ctrl-geocoder--input:focus {\n  outline: none !important;\n}\n\n.mapboxgl-ctrl-geocoder--button {\n  background: transparent !important;\n}\n\n.mapboxgl-ctrl-geocoder--icon-close {\n  fill: var(--map-text-muted) !important;\n  margin-top: 10px !important;\n}\n\n.mapboxgl-ctrl-geocoder .suggestions {\n  background: var(--map-bg) !important;\n  backdrop-filter: blur(16px) !important;\n  border: 1px solid var(--map-border) !important;\n  border-top: none !important;\n  border-radius: 0 0 18px 18px !important;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5) !important;\n  margin-top: 2px !important;\n  overflow: hidden;\n}\n\n.mapboxgl-ctrl-geocoder .suggestions > li > a {\n  color: var(--map-text-muted) !important;\n  font-size: 13px !important;\n  padding: 10px 16px !important;\n  border-bottom: 1px solid var(--map-border) !important;\n  transition: background 0.15s;\n}\n\n.mapboxgl-ctrl-geocoder .suggestions > .active > a,\n.mapboxgl-ctrl-geocoder .suggestions > li > a:hover {\n  background: var(--map-ctrl-hover) !important;\n  color: var(--map-text-primary) !important;\n}\n\n.mapboxgl-ctrl-geocoder .suggestions > li:last-child > a {\n  border-bottom: none !important;\n}\n\n.mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--suggestion-title {\n  color: var(--map-text-primary) !important;\n  font-weight: 500 !important;\n}\n\n.mapboxgl-ctrl-geocoder .mapboxgl-ctrl-geocoder--suggestion-address {\n  color: var(--map-text-muted) !important;\n  font-size: 11.5px !important;\n}\n\n.legend-wrapper {\n  position: absolute;\n  bottom: 250px;\n  left: 24px;\n  z-index: 10;\n}\n\n.mapboxgl-ctrl-bottom-right {\n  bottom: 20px !important;\n  right: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-end;\n}\n\n.mapboxgl-ctrl-group button .mapboxgl-ctrl-icon {\n  background-size: 26px 26px !important;\n}\n\n.mapboxgl-ctrl-group {\n  background: var(--map-ctrl-bg) !important;\n  backdrop-filter: blur(14px) !important;\n  -webkit-backdrop-filter: blur(14px) !important;\n  border: 1px solid var(--map-ctrl-border) !important;\n  border-radius: 12px !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;\n  overflow: hidden;\n}\n\n.mapboxgl-ctrl-group:not(:last-child) {\n  margin-bottom: 0 !important;\n}\n\n.mapboxgl-ctrl-group button {\n  background: transparent !important;\n  border: none !important;\n  border-bottom: 1px solid var(--map-border) !important;\n  width: 36px !important;\n  height: 36px !important;\n  cursor: pointer !important;\n  transition: background 0.18s !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.mapboxgl-ctrl-group button:last-child {\n  border-bottom: none !important;\n}\n\n.mapboxgl-ctrl-group button:hover {\n  background: var(--map-ctrl-hover) !important;\n}\n\n.mapboxgl-ctrl-group button:active {\n  background: var(--map-ctrl-active) !important;\n}\n\n.mapboxgl-ctrl-zoom-in .mapboxgl-ctrl-icon,\n.mapboxgl-ctrl-zoom-out .mapboxgl-ctrl-icon,\n.mapboxgl-ctrl-compass .mapboxgl-ctrl-icon,\n.mapboxgl-ctrl-fullscreen .mapboxgl-ctrl-icon,\n.mapboxgl-ctrl-shrink .mapboxgl-ctrl-icon,\n.mapboxgl-ctrl-geolocate .mapboxgl-ctrl-icon {\n  filter: var(--map-icon-filter) !important;\n  transition: filter 0.2s ease !important;\n}\n\n.mapboxgl-ctrl-group button:hover .mapboxgl-ctrl-icon {\n  filter: var(--map-icon-filter-hover) !important;\n}\n\n.mapboxgl-ctrl-geolocate-active .mapboxgl-ctrl-icon {\n  filter: var(--map-icon-filter-hover) !important;\n}\n\n.mapboxgl-user-location-dot {\n  background-color: var(--map-danger) !important;\n  box-shadow: 0 0 0 4px rgba(225, 6, 19, 0.3) !important;\n}\n\n.mapboxgl-user-location-dot::before {\n  background-color: rgba(225, 6, 19, 0.45) !important;\n}\n\n.legend-toggle-icon {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolygon points='12 2 2 7 12 12 22 7 12 2'/%3E%3Cpolyline points='2 12 12 17 22 12'/%3E%3Cpolyline points='2 17 12 22 22 17'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 20px 20px;\n  width: 100%;\n  height: 100%;\n  display: block;\n  transition: opacity 0.2s ease;\n}\n/* ── Département popup ── */\n.dept-popup .mapboxgl-popup-content {\n  background: rgba(23, 38, 49, 0.95);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 12px;\n  padding: 14px 18px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  color: #fff;\n  min-width: 140px;\n}\n\n.dept-popup .mapboxgl-popup-tip {\n  border-top-color: rgba(23, 38, 49, 0.95);\n}\n\n.dept-popup .mapboxgl-popup-close-button {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 16px;\n  padding: 6px 8px;\n  right: 4px;\n  top: 4px;\n  border-radius: 6px;\n  transition: color 0.2s, background 0.2s;\n  line-height: 1;\n}\n\n.dept-popup .mapboxgl-popup-close-button:hover {\n  color: #fff;\n  background: rgba(225, 6, 19, 0.25);\n}\n\n.dept-popup-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-right: 12px; \n}\n\n.dept-popup-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--map-text-muted, #8a9ba8);\n}\n\n.dept-popup-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--map-text-primary, #fff);\n}\n\n.dept-popup-id {\n  font-size: 11px;\n  color: var(--map-text-muted, #8a9ba8);\n  margin-top: 2px;\n}\n.legend-toggle-icon.legend-hidden {\n  opacity: 0.4;\n}\n\n.legend-toggle-icon.legend-hidden::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 20px;\n  height: 2px;\n  background: var(--map-danger);\n  transform: translate(-50%, -50%) rotate(-45deg);\n  border-radius: 1px;\n}\n\n.mapboxgl-ctrl-group button .legend-toggle-icon {\n  filter: var(--map-icon-filter) !important;\n  transition: filter 0.2s ease !important;\n}\n\n.mapboxgl-ctrl-group button:hover .legend-toggle-icon {\n  filter: var(--map-icon-filter-hover) !important;\n}\n.alert-fab {\n  z-index: 100;           /* higher than mapbox controls */\n  pointer-events: auto;\n}\n\n.alert-fab-desktop {\n  z-index: 100;          \n}\n\n.mapboxgl-ctrl-group {\n  pointer-events: auto;   \n}\n@media (max-width: 480px) {\n  .map-container {\n    height: 115dvh; \n  }\n}\n@media (max-width: 1000px) {\n  \n .mapboxgl-ctrl-top-right {\ntop: 14px;\nright: 14px;\nleft: auto; \n}\n.mapboxgl-ctrl-geocoder {\nmin-width: 0 !important;\nwidth: 200px !important; \n}\n\n  .mapboxgl-ctrl-geocoder--input {\n    font-size: 14px !important;\n    height: 40px !important;\n  }\n\n  .legend-wrapper {\n    bottom: 120px;\n    left: 12px;\n  }\n\n  .alert-cta-desktop {\n    display: none !important;\n  }\n\n  .alert-fab {\n    display: flex;\n  }\n\n  .mapboxgl-ctrl-bottom-right {\n    bottom: 16px !important;\n    right: 10px;\n  }\n\n  .mapboxgl-ctrl-group button {\n    width: 34px !important;\n    height: 34px !important;\n  }\n\n  .mapboxgl-ctrl-group button .mapboxgl-ctrl-icon {\n    background-size: 22px 22px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .mapboxgl-ctrl-top-right {\ntop: 10px;\nright: 10px;\nleft: 90px; \n}\n.mapboxgl-ctrl-geocoder {\nmin-width: 0 !important;\nwidth: 40% !important; \nborder-radius: 32px !important;\n}\n  .mapboxgl-ctrl-geocoder--input {\n    font-size: 15px !important;\n    height: 44px !important;\n  }\n\n  .legend-wrapper {\n    top: 100px;\n    left: 10px;\n  }\n\n  .alert-fab {\n    bottom: 120px;\n    left: 16px;\n    width: 52px;\n    height: 52px;\n    font-size: 24px;\n  }\n\n  .alert-modal {\n    padding: 28px 18px 40px;\n  }\n\n  .forecast-timeline-container {\n    bottom: 120px !important;\n  }\n\n  .forecast-timeline-pill {\n    min-width: 240px;\n    padding: 6px 12px;\n  }\n\n  .timeline-value {\n    font-size: 15px;\n  }\n\n  .timeline-value.hour {\n    font-size: 15px;\n  }\n\n  .timeline-timezone {\n    font-size: 8px;\n  }\n\n  .timeline-play-btn {\n    width: 32px;\n    height: 32px;\n  }\n\n  .timeline-play-btn svg {\n    width: 16px;\n    height: 16px;\n  }\n\n .map-container .mapboxgl-ctrl-bottom-right {\n    bottom: 120px !important;\n    right: 8px;\n     z-index: 10;  \n  }\n\n  .map-container .mapboxgl-ctrl-group button {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  .map-container .mapboxgl-ctrl-group button .mapboxgl-ctrl-icon {\n    background-size: 20px 20px !important;\n  }\n}\n\n@media (max-width: 360px) {\n .mapboxgl-ctrl-geocoder {\nmin-width: 0 !important;\nwidth: 40% !important; \nborder-radius: 32px !important;\n}\n  .mapboxgl-ctrl-geocoder--input {\n    font-size: 15px !important;\n    height: 44px !important;\n  }\n\n  .forecast-timeline-pill {\n    min-width: 210px;\n    padding: 5px 10px;\n  }\n\n  .timeline-value.date {\n    font-size: 13px;\n  }\n\n  .timeline-value.hour {\n    font-size: 14px;\n  }\n\n  .timeline-section.hour-section {\n    min-width: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
